import React from "react";
import { CButton } from "@coreui/react";
import { useNavigate } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";
import { FaExclamationTriangle } from "react-icons/fa";

const PaymentAlreadyDone = () => {
  const navigate = useNavigate();

  return (
    <div className="payment-failed-content--detail page-height">
      <div
        style={{
          background: "white",
          padding: "70px 60px",
          borderRadius: "6px",
        }}
      >
        <FaExclamationTriangle color="#bf2300" size={80} />
        <h3 className="mt-4">No transaction detail found. </h3>
        <div
          className="w-100"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "1.5rem",
          }}
        >
          <CButton color="primary" onClick={() => navigate("/")}>
            Go Back <BsArrowRight />
          </CButton>
        </div>
      </div>
    </div>
  );
};

export default PaymentAlreadyDone;
